import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchTransactionsRequest,
  fetchTransactionsSuccess,
  fetchTransactionsFailure,
  fetchInvoiceRequest,
  fetchInvoiceSuccess,
  fetchInvoiceFailure,
  exportTransactionsRequest,
  exportTransactionsSuccess,
  exportTransactionsFailure,
  verifyPaymentRequest,
  verifyPaymentSuccess,
  verifyPaymentFailure,
} from "./TransactionsSlice";
import { toast } from "react-toastify";

function* fetchTransactionsSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getTransactionDetails`,
        action.payload
      )
    );

    const resData = response.data;

    // API may return either data.orders or data.transactionData
    const transactionData =
      resData?.data?.orders ?? resData?.data?.transactionData ?? null;

    if (Array.isArray(transactionData)) {
      yield put(
        fetchTransactionsSuccess({
          transactionData,
          total: resData.data.total ?? 0,
          recordsFiltered: resData.data.recordsFiltered ?? transactionData.length,
          page: resData.data.page ?? 1,
          limit: resData.data.limit ?? 10,
        })
      );
    } else {
      yield put(fetchTransactionsFailure("No transaction data found."));
    }
  } catch (error) {
    yield put(fetchTransactionsFailure(error.message));
  }
}

function* fetchInvoiceSaga(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getInvoice/${action.payload}`
      )
    );

    const resData = response.data;

    if (resData) {
      yield put(fetchInvoiceSuccess(resData));
      toast.success("Invoice data fetched successfully!");
    } else {
      yield put(fetchInvoiceFailure("No invoice data found."));
    }
  } catch (error) {
    yield put(fetchInvoiceFailure(error.message));
  }
}

function* exportTransactionsSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/exportTransactions`,
        action.payload
      )
    );

    if (!response?.data?.success) {
      toast.error(response.data.message || "Export failed!");
      yield put(exportTransactionsFailure(response.data.message));
      return;
    }

    yield put(exportTransactionsSuccess(response.data));
    toast.success(response.data.message || "Export started!");
  } catch (error) {
    yield put(exportTransactionsFailure(error.message));
    toast.error("Export failed!");
  }
}

function* verifyPaymentSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/verify-status`,
        action.payload
      )
    );

    const delay = (seconds) => new Promise(resolve => setTimeout(resolve, seconds * 1000));
    if (response?.data?.success) {
      yield call(delay, 5); // backend will take some time to udpate the status
      yield put(verifyPaymentSuccess(response.data));
      
      action.payload.onSuccess();
      toast.success(response.data.message || "Payment Verified!");
    } else {
      yield put(verifyPaymentFailure(response.data.message));
      toast.error(response.data.message || "Verification failed!");
    }

  } catch (error) {
    yield put(verifyPaymentFailure(error.message));
    toast.error("Verification error!");
  }
}


export function* watchTransactionsSaga() {
  yield takeLatest(fetchTransactionsRequest.type, fetchTransactionsSaga);
  yield takeLatest(fetchInvoiceRequest.type, fetchInvoiceSaga);
  yield takeLatest(exportTransactionsRequest.type, exportTransactionsSaga);
  yield takeLatest(verifyPaymentRequest.type, verifyPaymentSaga);
}
